function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M226.996 16.7712C230.176 22.0092 228.067 24.6002 224.616 29.0542C220.373 34.5282 193.501 71.3272 193.501 71.3272C193.501 71.3272 180.783 68.2442 182.071 51.2202L207.736 22.1332C207.736 22.1332 208.559 12.9942 205.161 10.9752C201.64 8.88219 208.881 4.39419 213.745 11.8332C213.745 11.8332 219.599 1.9952 222.159 9.0432",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M226.996 16.7712C230.176 22.0092 228.067 24.6002 224.616 29.0542C220.373 34.5282 193.501 71.3272 193.501 71.3272C193.501 71.3272 180.783 68.2442 182.071 51.2202L207.736 22.1332C207.736 22.1332 208.559 12.9942 205.161 10.9752C201.64 8.88219 208.881 4.39419 213.745 11.8332C213.745 11.8332 219.599 1.9952 222.159 9.0432",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M183.87 74.0393L210.536 114.916C211.104 115.788 210.478 116.942 209.438 116.942H185.181C184.457 116.942 183.87 116.355 183.87 115.632V74.0393Z",
  fill: "#E1EAFF"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.037 118.135C22.531 118.135 20.5 116.534 20.5 114.559V56.51C20.5 54.535 22.531 52.934 25.037 52.934C25.037 52.934 93.655 53.012 116.528 53.012C122.081 53.012 122.222 56.156 122.206 58.054C122.193 59.555 122.018 66.054 122.018 66.054",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M105.085 110.447H33.2636C30.8496 110.447 28.8926 108.49 28.8926 106.075V101.974C28.8926 99.5601 30.8496 97.6021 33.2636 97.6021H105.085C107.499 97.6021 109.456 99.5601 109.456 101.974V106.075C109.456 108.49 107.499 110.447 105.085 110.447Z",
  fill: "#E1EAFF"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.865 91.6223H33.5286C30.9686 91.6223 28.8926 89.5463 28.8926 86.9863V83.4143C28.8926 80.8533 30.9686 78.7773 33.5286 78.7773H114.865C117.425 78.7773 119.501 80.8533 119.501 83.4143V86.9863C119.501 89.5463 117.425 91.6223 114.865 91.6223Z",
  fill: "#82A7FC"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.07 26.4259C50.846 25.6499 51.658 24.9099 52.504 24.2099C55.11 22.0489 58.035 20.2579 61.196 18.9169C65.402 17.1339 70.028 16.1479 74.884 16.1479C94.265 16.1479 109.976 31.8589 109.976 51.2399C109.976 70.6209 94.265 86.3319 74.884 86.3319C55.504 86.3319 39.792 70.6209 39.792 51.2399C39.792 46.5949 40.694 42.1619 42.333 38.1049",
  fill: "white"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M50.07 26.4259C50.846 25.6499 51.658 24.9099 52.504 24.2099C55.11 22.0489 58.035 20.2579 61.196 18.9169C65.402 17.1339 70.028 16.1479 74.884 16.1479C94.265 16.1479 109.976 31.8589 109.976 51.2399C109.976 70.6209 94.265 86.3319 74.884 86.3319C55.504 86.3319 39.792 70.6209 39.792 51.2399C39.792 46.5949 40.694 42.162 42.333 38.1049",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M77.5421 78.9914C69.2291 79.7824 60.6541 76.8444 54.5141 70.2704C49.2581 64.6454 46.7801 57.4224 47.0231 50.2924C47.0841 48.5134 47.3131 46.7414 47.7121 44.9994",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5421 78.9914C69.2291 79.7824 60.6541 76.8444 54.5141 70.2704C49.2581 64.6454 46.7801 57.4224 47.0231 50.2924C47.0841 48.5134 47.3131 46.7414 47.7121 44.9994",
  stroke: "#126DFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.8535 30.8689C67.1045 20.3589 84.7455 20.9589 95.2555 32.2089C99.1975 36.4289 101.577 41.5459 102.417 46.8489C103.819 55.6879 100.947 65.0419 93.9155 71.6109",
  fill: "white"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M55.8535 30.8689C67.1045 20.3589 84.7455 20.9589 95.2555 32.2089C99.1975 36.4289 101.577 41.5459 102.417 46.8489C103.819 55.6879 100.947 65.0419 93.9155 71.6109",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M67.3134 60.7351L87.1224 40.9251C87.9664 40.0821 89.3344 40.0821 90.1784 40.9251L90.4404 41.1871C91.2844 42.0311 91.2844 43.3991 90.4404 44.2431L70.6304 64.0531C69.7874 64.8971 68.4174 64.8971 67.5744 64.0531L67.3134 63.7921C66.4684 62.9471 66.4684 61.5791 67.3134 60.7351Z",
  fill: "#34C724"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.5157 51.366L70.6917 60.542C71.6077 61.458 71.6077 62.944 70.6917 63.86C69.7757 64.776 68.2897 64.776 67.3727 63.86L58.1977 54.684C57.2817 53.767 57.2817 52.282 58.1977 51.366C59.1137 50.45 60.5987 50.45 61.5157 51.366Z",
  fill: "#34C724"
});
var _ref16 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 30,
  y: 117,
  width: 192,
  height: 2
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.9561 117.775H221.915V118.775H30.9561V117.775Z",
  fill: "white"
}));
var _ref17 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M221.915 118.275H30.9561",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.0723 30.7019L35.2853 32.5999L32.0723 30.7019Z",
  fill: "white"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0723 30.7019L35.2853 32.5999",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M34.2461 23.6233L37.5791 26.6233L34.2461 23.6233Z",
  fill: "white"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2461 23.6233L37.5791 26.6233",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M116.539 37.2815L113.148 38.9205L116.539 37.2815Z",
  fill: "white"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M116.539 37.2815L113.148 38.9205",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M119.225 41.7429L114.256 42.8359L119.225 41.7429Z",
  fill: "white"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M119.225 41.7429L114.256 42.8359",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M114.944 30.7219L112.164 33.6369L114.944 30.7219Z",
  fill: "white"
});
var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M114.944 30.7219L112.164 33.6369",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M93.168 103.888H109.456",
  stroke: "#126DFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7842 103.888H82.8022",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref30 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M170.217 49.8585L168.346 42.8035L164.621 41.7265C164.224 41.3465 164.209 40.7105 164.589 40.3125L168.513 39.3035L169.424 35.2505C169.804 34.8525 170.44 34.8375 170.838 35.2175L172.513 39.2205L176.141 40.2825C176.538 40.6625 176.553 41.2985 176.173 41.6965L172.263 42.8875L171.631 49.8255C171.251 50.2235 170.615 50.2385 170.217 49.8585Z",
  fill: "#FFC60A"
});
var _ref31 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.3542 48.5397L31.4712 45.0067L29.3462 44.3917C29.1202 44.1747 29.1112 43.8117 29.3282 43.5847L31.5662 43.0097L32.0852 40.6977C32.3022 40.4707 32.6662 40.4627 32.8922 40.6797L33.8482 42.9617L35.9172 43.5687C36.1442 43.7857 36.1532 44.1477 35.9362 44.3747L33.7062 45.0537L33.1612 48.5207C32.9442 48.7477 32.5822 48.7557 32.3542 48.5397Z",
  fill: "#FFC60A"
});
var _ref32 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.9069 42.6624L43.8969 34.6234L39.0639 33.2254C38.5479 32.7324 38.5289 31.9074 39.0209 31.3914L44.1139 30.0814L45.2969 24.8214C45.7889 24.3054 46.6149 24.2864 47.1309 24.7794L49.3039 29.9734L54.0129 31.3524C54.5299 31.8454 54.5489 32.6714 54.0549 33.1874L48.9799 34.7324L47.7419 42.6204C47.2489 43.1364 46.4229 43.1554 45.9069 42.6624Z",
  fill: "#FFC60A"
});
var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47.9561 14.804L49.4561 19.054L47.9561 14.804Z",
  fill: "white"
});
var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M47.9561 14.804L49.4561 19.054",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref35 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.636 39.4616C153.636 39.4616 157.835 37.5336 157.534 42.8406C157.235 48.1476 151.873 46.8056 151.873 46.8056L153.636 39.4616Z",
  fill: "white"
});
var _ref36 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M153.636 39.4616C153.636 39.4616 157.835 37.5336 157.534 42.8406C157.235 48.1476 151.873 46.8056 151.873 46.8056L153.636 39.4616Z",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref37 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.501 90.9753C98.501 90.9753 91.952 97.2593 88.552 103.555C85.196 109.768 99.068 118.275 99.068 118.275H125.639L114.846 108.174L117.666 105.198L98.501 90.9753Z",
  fill: "white"
});
var _ref38 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.501 90.9753C98.501 90.9753 91.952 97.2593 88.552 103.555C85.196 109.768 99.068 118.275 99.068 118.275H125.639L114.846 108.174L117.666 105.198L98.501 90.9753Z",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M163.442 24.3358L173.606 23.9348",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M159.466 16.7492L166.368 9.46619",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M161.58 20.4089L167.051 19.1489",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref42 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.902 29.675C141.902 29.675 153.326 29.38 153.926 38.037C154.528 46.694 150.32 55.735 150.32 55.735C150.32 55.735 151.823 65.332 159.638 67.737C167.455 70.142 147.614 79.762 138.295 67.737C138.295 67.737 142.804 63.228 141.001 56.614C141.001 56.614 133.871 54.914 133.749 48.639C133.574 39.58 130.479 29.49 141.902 29.675Z",
  fill: "white"
});
var _ref43 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M141.902 29.675C141.902 29.675 153.326 29.38 153.926 38.037C154.528 46.694 150.32 55.735 150.32 55.735C150.32 55.735 151.823 65.332 159.638 67.737C167.455 70.142 147.614 79.762 138.295 67.737C138.295 67.737 142.804 63.228 141.001 56.614C141.001 56.614 133.871 54.914 133.749 48.639C133.574 39.58 130.479 29.49 141.902 29.675Z",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref44 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M184.372 47.054C189.749 50.215 195.539 62.887 196.104 77.048L184.751 93.804L184.72 88.364C184.773 92.625 184.793 118.275 184.793 118.275H123.004L122.033 88.517L122.357 100.982L117.666 105.199L96.876 90.447C96.876 90.447 117.367 72.196 121.733 70.31C130.131 66.684 164.372 61.721 168.372 60.387L184.372 47.054Z",
  fill: "#3370FF"
});
var _ref45 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M184.372 47.054C189.749 50.215 195.539 62.887 196.104 77.048L184.751 93.804L184.72 88.364C184.773 92.625 184.793 118.275 184.793 118.275H123.004L122.033 88.517L122.357 100.982L117.666 105.199L96.876 90.447C96.876 90.447 117.367 72.196 121.733 70.31C130.131 66.684 164.372 61.721 168.372 60.387L184.372 47.054Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref46 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M155.502 30.7424C155.48 31.1754 155.881 50.1904 142.25 46.7904C128.619 43.3904 118.775 19.8574 135.372 20.5304C141.106 20.7624 156.057 20.3584 155.502 30.7424Z",
  fill: "#FFC60A"
});
var _ref47 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M222.969 11.0266C222.969 11.0266 226.219 10.4016 225.969 14.5266L222.969 11.0266Z",
  fill: "white"
});
var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M222.969 11.0266C222.969 11.0266 226.219 10.4016 225.969 14.5266",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M212.724 52.9114L200.39 71.2444",
  stroke: "#3370FF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgPcQuestionnaireSubmitted = function SvgPcQuestionnaireSubmitted(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 125,
    viewBox: "0 0 250 125",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPcQuestionnaireSubmitted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pc_questionnaire_submitted.afabe7de.svg";
export { ForwardRef as ReactComponent };